export default {
  header: 'Menu',
  tabs: {
    menu: 'Menu',
    modifier_groups: 'Tilvalg',
  },
  toasts: {
    failed_to_load_data: 'Menuen kunne ikke indlæses. Opdater og prøv igen',
  },
};
